import { createAction, props } from '@ngrx/store';
import { RequirementOverrideDetail } from '../../models/requirement-override-detail.model';
import { SaveQualificationSettingsOverrideRequest } from '../../api/models/save-qualification-settings-override-request.model';
import { RequirementQualificationSettingOverrideDetailsDto } from '../../api/models/requirement-qualification-setting-override-details-dto.model';
import { DocumentTypeLevelType } from '../../models/requirement-descriptions.model';

export const loadRequirementOverrideDetails = createAction(
    '[REQUIREMENT OVERRIDE] Load Requirement Override Details',
    props<{ documentTypeId: number; entityType: DocumentTypeLevelType; entityId: number }>()
);

export const loadRequirementOverrideDetailsSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Load Requirement Override Details Successfully',
    props<{ details: RequirementOverrideDetail }>()
);

export const loadRequirementOverrideDetailsFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Load Requirement Override Details Failure',
    props<{ error: unknown }>()
);

export const setRequirementOverrideIsLoadingFlag = createAction(
    '[REQUIREMENT OVERRIDE] Set Requirement Override IsLoading Flag',
    props<{
        isLoading: boolean;
    }>()
);

export const saveRequirementsQualificationSettingsOverride = createAction(
    '[REQUIREMENT OVERRIDE] Save Requirements Qualification Settings Override',
    props<{ documentTypeId: number; request: SaveQualificationSettingsOverrideRequest }>()
);

export const saveRequirementsQualificationSettingsOverrideSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Save Requirements Qualification Settings Override Successfully',
    props<{ details: RequirementQualificationSettingOverrideDetailsDto }>()
);

export const saveRequirementsQualificationSettingsOverrideFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Save Requirements Qualification Settings Override Failure',
    props<{ error: unknown }>()
);

export const saveRequirementsManualReviewOverride = createAction(
    '[REQUIREMENT OVERRIDE] Save Requirements Manual Review Override',
    props<{ documentTypeId: number; request: SaveQualificationSettingsOverrideRequest }>()
);

export const saveRequirementsManualReviewOverrideSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Save Requirements Manual Review Override Successfully',
    props<{ details: RequirementQualificationSettingOverrideDetailsDto }>()
);

export const saveRequirementsManualReviewOverrideFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Save Requirements Manual Review Override Failure',
    props<{ error: unknown }>()
);

export const deleteRequirementQualificationSettingsOverride = createAction(
    '[REQUIREMENT OVERRIDE] Delete Requirement Qualification Settings Override',
    props<{ documentTypeId: number; entityType: DocumentTypeLevelType; entityId: number }>()
);

export const deleteRequirementQualificationSettingsOverrideSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Delete Requirement Qualification Settings Override Successfully',
    props<{ details: RequirementQualificationSettingOverrideDetailsDto }>()
);

export const deleteRequirementQualificationSettingsOverrideFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Delete Requirement Qualification Settings Override Failure',
    props<{ error: unknown }>()
);

export const deleteRequirementManualReviewOverride = createAction(
    '[REQUIREMENT OVERRIDE] Delete Requirement Manual Review Override',
    props<{ documentTypeId: number; entityType: DocumentTypeLevelType; entityId: number }>()
);

export const deleteRequirementManualReviewOverrideSuccessfully = createAction(
    '[REQUIREMENT OVERRIDE API] Delete Requirement Manual Review Override Successfully',
    props<{ details: RequirementQualificationSettingOverrideDetailsDto }>()
);

export const deleteRequirementManualReviewOverrideFailure = createAction(
    '[REQUIREMENT OVERRIDE API] Delete Requirement Manual Review Override Failure',
    props<{ error: unknown }>()
);
